<template>
  <v-bottom-sheet v-if="sheetMode" :value="sheet" @input="update">
    <!-- Slots depend on how and where content is rendered
    Left and right slots are the position on the footer not on the popup/sheet.
    appending "Sheet" following the left or right is whether it appears in the sheet or only on the footer -->
    <!-- Includes a footer for ease of use -->
    <template #activator="scope">
      <bm-page-footer>
        <template #left>
          <div class="no-sheet">
            <slot name="left-not-in-sheet" />
            <slot v-if="usesInSheetSlots" name="activator" v-bind="scope" />
          </div>
        </template>
        <div class="no-sheet">
          <slot />
        </div>
      </bm-page-footer>
    </template>
    <v-sheet>
      <v-flex class="sheet-container">
        <slot name="right-in-sheet" />
        <slot name="left-in-sheet" />
        <!-- Default Cancel button is rendered here -->
        <slot name="cancel">
          <bm-btn
            btn-class="mr-2"
            icon
            dark
            button-type="primary"
            data-qa="bottom-sheet-close"
            @click="update(false)"
            ><v-icon light>close</v-icon></bm-btn
          >
        </slot>
      </v-flex>
    </v-sheet>
  </v-bottom-sheet>
  <!-- If Sheet Mode not set, Content is rendered here -->
  <bm-page-footer v-else>
    <template #left>
      <div class="no-sheet">
        <slot name="left-not-in-sheet" /><slot name="left-in-sheet" />
      </div>
    </template>
    <div class="no-sheet"><slot name="right-in-sheet" /><slot /></div>
  </bm-page-footer>
</template>

<script lang="ts">
import BmPageFooter from "@/components/pages/BmPageFooter.vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "BmBottomSheet",
  components: { BmPageFooter },
  model: {
    prop: "sheet",
    event: "input",
  },
  props: {
    sheetMode: {
      type: Boolean,
      default: false,
    },
    sheet: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    usesInSheetSlots(): any {
      return (
        !!this.$slots["right-in-sheet"] ||
        !!this.$slots["left-in-sheet"] ||
        !!this.$slots["cancel"]
      );
    },
    slots(): any {
      return this.$slots;
    },
  },
  methods: {
    update(newValue: boolean) {
      this.$emit("input", newValue);
    },
  },
});
</script>

<style scoped lang="sass">

.sheet-container
  text-align: center
  padding: 10px
// Add class full-width to maximise child element size
.sheet-container :deep(.full-width)
  width: 100%
  margin: 5px auto

.no-sheet :deep(.full-width), :deep(.more)
  margin: auto 3px
</style>
